import React from 'react'
import { connect } from 'react-redux'
import withStyles from 'isomorphic-style-loader/lib/withStyles'
import _get from 'lodash/get'

import Link from '@components/Link'
import Layout from '@components/Molalayout'
import LazyLoad from '@components/common/Lazyload'

import Button from '@components/Button'
import { notFoundImg, internalServerErrImg } from '@global/imageUrl'

import styles from './error.css'

const Error = ({ className = '', title = '', message = '', status = 1 /** none, 400, 502 */, errorCodes }) => {
  let imageUri,
    description,
    buttonText = _get(errorCodes, `error_page.${status}.button_text`, 'Back to Home'),
    isRefresh = false

  imageUri = internalServerErrImg
  title = _get(errorCodes, `error_page.${status}.title`, 'An error occurred while loading this page.')
  description = _get(
    errorCodes,
    `error_page.${status}.description`,
    'Please refresh this page or return to Home via the button below',
  )

  if (status == 403 || status == 404) {
    imageUri = notFoundImg
  }

  if (message.indexOf('timeout') > -1) {
    title = _get(errorCodes, `error_page.timeout.title`, '')
    description = _get(
      errorCodes,
      `error_page.timeout.description`,
      'There was a connection error. Please check your internet network again, or try to refresh this page',
    )
    buttonText = _get(errorCodes, `error_page.timeout.button_text`, 'Refresh')
    isRefresh = true
  }
  return (
    <Layout noHeader>
      <LazyLoad>
        <div className={`${styles.error__container} ${className}`}>
          {/* <img alt="mola" className={styles.error__mola_title} src={molaLogo} /> */}
          <div className={styles.error__wrapper}>
            <img alt="mola error background" className={styles.error__mola_background} src={imageUri} />
            <h2 className={styles.error__title}>{title}</h2>
            <p className={styles.error__description}>{description}</p>
            <p className={styles.error__message}>{message}</p>
            <Button
              name={buttonText}
              buttonStyle={{ marginTop: 0 }}
              className={styles.button__error}
              handleOnClick={() => {
                isRefresh ? location.reload() : (window.location.href = '/')
              }}
            />
          </div>
        </div>
      </LazyLoad>
    </Layout>
  )
}

const mapStateToProps = state => {
  return {
    errorCodes: state.configParams.errorCodes || null,
  }
}

const Default = withStyles(styles)(Error)
export default connect(mapStateToProps, null)(Default)
